import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { LicensesComponent } from './licenses.component';
import { LicensesFiltersComponent } from './licenses-filters/licenses-filters.component';

import { ListService } from '../list.service';

import { AngularMaterialModule } from '../angular-material.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule
  ],
  providers: [
    LicensesFiltersComponent,
    ListService
  ],
  declarations: [
    LicensesComponent,
    LicensesFiltersComponent
  ],
  exports: [
    LicensesComponent
  ]
})

export class LicensesModule { }
